import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AchievementDialog from './AchievementDialog';
import BookChangeToast from './BookChangeToast';
import { accessibleLevelName } from '../../helper/Helper'

class Notification extends Component  {
    componentWillUpdate(nextProps, nextState) {
        this.notifiStatusUpdate(nextProps)
    }

    static propTypes = {
        readBooksNum: PropTypes.number.isRequired,
        markedBooksNum: PropTypes.number.isRequired,
        isHighGrade: PropTypes.bool.isRequired,
        isShowPersonalBookError: PropTypes.bool,
        isShowSeriesError: PropTypes.bool,
        isShowPrcBookError: PropTypes.bool,
        personalBookNum: PropTypes.number,
        levelName: PropTypes.string,
        levelImage: PropTypes.string,
    };

    state = {
        isToastOpen: false,
        isDialogOpen: false,
        isAddToList: false,
        isReadLog: false,
        showPersonalError: false,
        showSeriesError: false,
        showPrcBookError: false,
        userLevel: 0
    }

    notifiStatusUpdate = (nextProps) => {
        const updateReadNumber = nextProps.readBooksNum;
        const currentReadNumber = this.props.readBooksNum;
        const isComplete = updateReadNumber > (this.props.isHighGrade ? 20 : 30);

        if(this.state.ignoreNextPopUp){
            this.setState({ignoreNextPopUp : false})
            return
        }
        // render error pop-up if user add more than 5 personal choice book
        if (this.props.isShowPersonalBookError !== nextProps.isShowPersonalBookError
            && nextProps.isShowPersonalBookError){
            this.setState({
                isDialogOpen: true,
                showPersonalError: true, //still need set local state as props change will trigger dialog content change
                showSeriesError: false,
                showPrcBookError: false,
            })
        } else if (nextProps.isShowPrcBookError !== this.props.isShowPrcBookError
            && nextProps.isShowPrcBookError) {
            this.setState({
                isDialogOpen: true,
                showPersonalError: false,
                showSeriesError: false,
                showPrcBookError: true,
            })
        // render error pop-up if more than 2 books from same Series in read list
        } else if (nextProps.isShowSeriesError !== this.props.isShowSeriesError
            && nextProps.isShowSeriesError) {
            this.setState({
                isDialogOpen: true,
                showPersonalError: false,
                showSeriesError: true,
                showPrcBookError: false,
            })
        //render level-up dialog every 5 books, not for extra book
        } else if (updateReadNumber > currentReadNumber) {
            if(!isComplete && updateReadNumber % 5 === 0 ){
                this.setState({
                    showPersonalError: false,
                    showSeriesError: false,
                    showPrcBookError: false,
                    isDialogOpen: true,
                    userLevel: updateReadNumber / 5,
                    ignoreNextPopUp: true // avoid trigger toast of remove from reading plan
                })
        //render add reading log Toast
            } else {
                this.setState({
                    isToastOpen: true,
                    isAddToList: true,
                    isReadLog: true,
                    ignoreNextPopUp: true
                })
            }
        //render remove from reading log Toast
        } else if (updateReadNumber < currentReadNumber){
            this.setState({
                isToastOpen: true,
                isAddToList: false,
                isReadLog: true
            })
        //render add reading plan Toast
        } else if (nextProps.markedBooksNum > this.props.markedBooksNum){
            this.setState({
                isToastOpen: true,
                isAddToList: true,
                isReadLog: false
            })
        //render remove from reading plan Toast
        } else if (nextProps.markedBooksNum < this.props.markedBooksNum){
            this.setState({
                isToastOpen: true,
                isAddToList: false,
                isReadLog: false
            })
        }
    }

    notifiCloseHandler = () => {
        this.setState({
            isToastOpen: false,
        })
    }

    dialogCloseHandler = () => {
        this.setState({ isDialogOpen: false });
    }


    render() {
        const {
            isToastOpen,
            isDialogOpen,
            isAddToList,
            isReadLog,
            userLevel,
            showPersonalError,
            showSeriesError,
            showPrcBookError
        } = this.state;
        const {
            readBooksNum,
            personalBookNum,
            isHighGrade,
            levelName,
            levelImage
        } = this.props;
        const isAccomplished = isHighGrade? userLevel === 4 : userLevel === 6
        return (
            <div>
                <BookChangeToast
                    isOpen={isToastOpen}
                    isAdd={isAddToList}
                    isReadLog={isReadLog}
                    closeHandler={this.notifiCloseHandler}
                />
                <AchievementDialog
                    readBooksNum={readBooksNum}
                    personalBookNum={personalBookNum}
                    isOpen={isDialogOpen}
                    dialogCloseHandler={this.dialogCloseHandler}
                    userLevel={userLevel}
                    isHighGrade={isHighGrade}
                    showPersonalError={showPersonalError}
                    showSeriesError={showSeriesError}
                    levelName={levelName}
                    levelImage={levelImage}
                    accessibilityImgName={accessibleLevelName(levelName)}
                    showPrcBookError={showPrcBookError}
                    isAccomplished={isAccomplished}
                />
            </div>
        );
    }
}

export default Notification;
